export default __webpack_public_path__ + "static/char-47-bc14c2b7db51775cac6b5ec03bed4ede.gif";